import React from 'react';
import { Flex } from 'rebass';
// import { useGetCelebration } from '@/hooks/api';
// import { sendTrackingEvent } from '@/lib/helper';
// import { postPrivateEventDetails } from '@/lib/api';
import StripeForm from './StripeForm';

export default function PaymentPage({ ...props }) {
  return (
    <Flex flexDirection="column" m="auto" mb={3} mt={[0, 4]}>
      <StripeForm  {...props} />
    </Flex>
  );
}
